export type MfaMode = "off" | "optional" | "always";
export type MfaUserState = "enrolled" | "opted-out" | "unknown";

export const asMfaMode = (value: string | null | undefined): MfaMode =>
  value === "optional" || value === "always" ? value : "off";

export const deriveMfaUserState = (enrolled: boolean, optedOut: boolean): MfaUserState =>
  enrolled ? "enrolled" : optedOut ? "opted-out" : "unknown";

/** Whether to proactively offer enrollment via the in-app modal. */
export const shouldOfferMfa = (mode: MfaMode, state: MfaUserState): boolean =>
  mode === "optional" && state === "unknown";

export type MfaSettingsView = "unavailable" | "enable" | "disable" | "required";

/** What the account-settings MFA section should render. */
export const mfaSettingsView = (mode: MfaMode, state: MfaUserState): MfaSettingsView => {
  if (mode === "off") return "unavailable";
  if (mode === "always") return "required";
  return state === "enrolled" ? "disable" : "enable";
};

/** A user may only disable their own MFA in optional mode once enrolled. */
export const canDisableMfa = (mode: MfaMode, state: MfaUserState): boolean =>
  mode === "optional" && state === "enrolled";
